<template>
  <v-navigation-drawer
    v-model="showFilter"
    :fixed="!isImport"
    :absolute="isImport"
    right
    :height="filterHeight"
    width="300"
    style="margin-top: 65px"
  >
    <v-list :expand="true">
      <v-list-group :value="false">
        <template v-slot:activator>
          <v-list-item-title>
            <div class="paddingLeft" :class="{ activeFilterLabel: determineIfActiveArray(filter.energiedeskundigen) }">
              {{ $t('opdrachten.filter.energiedeskundige') }}
            </div>
          </v-list-item-title>
        </template>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>
              <v-autocomplete
                clearable
                v-model="filter.energiedeskundigen"
                :items="filterOptions.energiedeskundigen"
                item-text="omschrijving"
                item-value="code"
                multiple
                small-chips
                chips
              >
                <template v-slot:prepend-item>
                  <v-list-item
                    ripple
                    @click="
                      filter.energiedeskundigen = toggleAllOrNothing(
                        filter.energiedeskundigen,
                        filterOptions.energiedeskundigen
                      )
                    "
                  >
                    <v-list-item-action>
                      <v-icon
                        v-if="filter.energiedeskundigen.length === filterOptions.energiedeskundigen.length"
                        color="#105269"
                      >
                        mdi-checkbox-marked
                      </v-icon>
                      <v-icon v-else>mdi-checkbox-blank-outline</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title>
                        {{ $t('acties.selecteer-alles') }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider class="mt-2"></v-divider>
                </template>
              </v-autocomplete>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>
      <v-list-group :value="false" v-if="!excludedFilters.includes('OpdrachtStatus')">
        <template v-slot:activator>
          <v-list-item-title>
            <div class="paddingLeft" :class="{ activeFilterLabel: determineIfActiveArray(filter.opdrachtStatussen) }">
              {{ $t('opdrachten.filter.status-opdracht') }}
            </div>
          </v-list-item-title>
        </template>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>
              <v-autocomplete
                clearable
                multiple
                v-model="filter.opdrachtStatussen"
                :items="filterOptions.opdrachtStatussen"
                item-value="code"
                item-text="omschrijving"
                small-chips
                chips
              >
                <template v-slot:prepend-item>
                  <v-list-item
                    ripple
                    @click="
                      filter.opdrachtStatussen = toggleAllOrNothing(
                        filter.opdrachtStatussen,
                        filterOptions.opdrachtStatussen
                      )
                    "
                  >
                    <v-list-item-action>
                      <v-icon
                        v-if="filter.opdrachtStatussen.length === filterOptions.opdrachtStatussen.length"
                        color="#105269"
                      >
                        mdi-checkbox-marked
                      </v-icon>
                      <v-icon v-else>mdi-checkbox-blank-outline</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title>
                        {{ $t('acties.selecteer-alles') }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider class="mt-2"></v-divider>
                </template>
              </v-autocomplete>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>
      <v-list-group :value="false">
        <template v-slot:activator>
          <v-list-item-title>
            <div
              class="paddingLeft"
              :class="{ activeFilterLabel: determineIfActiveArray(filter.certificaatStatussen) }"
            >
              {{ $t('opdrachten.filter.status-certificaat') }}
            </div>
          </v-list-item-title>
        </template>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>
              <v-autocomplete
                clearable
                multiple
                v-model="filter.certificaatStatussen"
                :items="filterOptions.certificaatStatussen"
                item-text="omschrijving"
                item-value="code"
                small-chips
                chips
              >
                <template v-slot:prepend-item>
                  <v-list-item
                    ripple
                    @click="
                      filter.certificaatStatussen = toggleAllOrNothing(
                        filter.certificaatStatussen,
                        filterOptions.certificaatStatussen
                      )
                    "
                  >
                    <v-list-item-action>
                      <v-icon
                        v-if="filter.certificaatStatussen.length === filterOptions.certificaatStatussen.length"
                        color="#105269"
                      >
                        mdi-checkbox-marked
                      </v-icon>
                      <v-icon v-else>mdi-checkbox-blank-outline</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title>
                        {{ $t('acties.selecteer-alles') }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider class="mt-2"></v-divider>
                </template>
              </v-autocomplete>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>
      <v-list-group :value="false">
        <template v-slot:activator>
          <v-list-item-title>
            <div class="paddingLeft" :class="{ activeFilterLabel: determineIfActiveArray(filter.bestemmingen) }">
              {{ $t('opdrachten.filter.bestemming') }}
            </div>
          </v-list-item-title>
        </template>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>
              <v-autocomplete
                clearable
                multiple
                v-model="filter.bestemmingen"
                :items="filterOptions.bestemmingen"
                item-text="omschrijving"
                item-value="code"
                small-chips
                chips
              >
                <template v-slot:prepend-item>
                  <v-list-item
                    ripple
                    @click="filter.bestemmingen = toggleAllOrNothing(filter.bestemmingen, filterOptions.bestemmingen)"
                  >
                    <v-list-item-action>
                      <v-icon v-if="filter.bestemmingen.length === filterOptions.bestemmingen.length" color="#105269">
                        mdi-checkbox-marked
                      </v-icon>
                      <v-icon v-else>mdi-checkbox-blank-outline</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title>
                        {{ $t('acties.selecteer-alles') }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider class="mt-2"></v-divider>
                </template>
              </v-autocomplete>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>
      <v-list-group :value="false">
        <template v-slot:activator>
          <v-list-item-title>
            <div class="paddingLeft" :class="{ activeFilterLabel: determineIfActiveBoolean(filter.publiekGebouw) }">
              {{ $t('opdrachten.filter.publiek-gebouw') }}
            </div>
          </v-list-item-title>
        </template>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>
              <v-select clearable :items="filterOptions.booleanOptie" v-model="filter.publiekGebouw" />
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>
      <v-list-group :value="false">
        <template v-slot:activator>
          <v-list-item-title>
            <div class="paddingLeft" :class="{ activeFilterLabel: determineIfActiveBoolean(filter.overheidsgebouw) }">
              {{ $t('opdrachten.filter.overheidsgebouw') }}
            </div>
          </v-list-item-title>
        </template>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>
              <v-select clearable :items="filterOptions.booleanOptie" v-model="filter.overheidsgebouw" />
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>
      <v-list-group :value="false">
        <template v-slot:activator>
          <v-list-item-title>
            <div class="paddingLeft" :class="{ activeFilterLabel: determineIfActiveObject(filter.aanmaakdatum) }">
              {{ $t('opdrachten.filter.aanmaakdatum') }}
            </div>
          </v-list-item-title>
        </template>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>
              <date-picker
                :clearable="true"
                :label="$t('opdrachten.filter.van')"
                v-model="filter.aanmaakdatum.van"
                :nudge="-320"
                :offset-y="false"
                @clear="clearData('aanmaakdatum', 'van')"
              />
              <date-picker
                :clearable="true"
                :label="$t('opdrachten.filter.tot')"
                v-model="filter.aanmaakdatum.tot"
                :nudge="-320"
                :offset-y="false"
                @clear="clearData('aanmaakdatum', 'tot')"
              />
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>
      <v-list-group :value="false">
        <template v-slot:activator>
          <v-list-item-title>
            <div class="paddingLeft" :class="{ activeFilterLabel: determineIfActiveObject(filter.indiendatum) }">
              {{ $t('opdrachten.filter.indiendatum') }}
            </div>
          </v-list-item-title>
        </template>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>
              <date-picker
                :clearable="true"
                :label="$t('opdrachten.filter.van')"
                v-model="filter.indiendatum.van"
                :nudge="-320"
                :offset-y="false"
                @clear="clearData('indiendatum', 'van')"
              />
              <date-picker
                :clearable="true"
                :label="$t('opdrachten.filter.tot')"
                v-model="filter.indiendatum.tot"
                :nudge="-320"
                :offset-y="false"
                @clear="clearData('indiendatum', 'tot')"
              />
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>
      <v-list-group :value="false">
        <template v-slot:activator>
          <v-list-item-title>
            <div class="paddingLeft" :class="{ activeFilterLabel: determineIfActiveArray(filter.labels) }">
              {{ $t('opdrachten.filter.label') }}
            </div>
          </v-list-item-title>
        </template>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>
              <v-autocomplete
                clearable
                v-model="filter.labels"
                :items="filterOptions.labels"
                item-text="omschrijving"
                item-value="code"
                multiple
                small-chips
                chips
              />
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>
      <v-list-group :value="false">
        <template v-slot:activator>
          <v-list-item-title>
            <div class="paddingLeft" :class="{ activeFilterLabel: determineIfActiveObject(filter.energiescore) }">
              {{ $t('opdrachten.filter.energiescore') }}
            </div>
          </v-list-item-title>
        </template>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>
              <number-input
                :clearable="true"
                :precision="0"
                v-model="filter.energiescore.van"
                :max="filter.energiescore.tot"
                :label="$t('opdrachten.filter.van')"
              />
              <number-input
                :clearable="true"
                :precision="0"
                v-model="filter.energiescore.tot"
                :min="filter.energiescore.van"
                :label="$t('opdrachten.filter.tot')"
              />
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>
    </v-list>
    <template v-slot:append>
      <v-divider />
      <v-btn small class="ma-2 primary" @click="handleSave">{{ $t('acties.zoeken') }}</v-btn>
      <v-btn small class="ma-2 v-btn--is-elevated" outlined @click="$emit('reset')">{{ $t('acties.reset') }}</v-btn>
      <v-btn small class="ma-2" @click="cancel">{{ $t('acties.annuleren') }}</v-btn>
    </template>
  </v-navigation-drawer>
</template>
<style scoped>
.activeFilterLabel {
  font-weight: bold;
  color: rgba(0, 0, 0, 0.7);
  vertical-align: middle;
}
.activeFilterLabel::before {
  content: '';
  border-radius: 50%;
  width: 12px;
  height: 12px;
  background-color: teal;
  color: white;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  font-size: 13px;
  position: absolute;
  left: 14px;
  bottom: 18px;
}
.paddingLeft {
  padding-left: 20px;
}
</style>

<script lang="ts">
import { Component, Inject, Prop, Vue, Watch } from 'vue-property-decorator';
import DatePicker from '@/components/form/DatePicker.vue';
import NumberInput from '@/components/form/NumberInput.vue';
import { Filter } from '@/domain/interface/Filter';
import { fetchIndependentEnum } from '@/util/enum/enumUtils';
import GebruikerService from '@/services/GebruikerService';
import { EnumInterface } from '@/domain/interface/intern/enumvalues/EnumInterface';
import ActiveFilterIndicator from '@/views/partials/filter/ActiveFilterIndicator.vue';
import { determineIfActiveArray, determineIfActiveBoolean, determineIfActiveObject } from '@/util/filters/filterUtil';

@Component({
  methods: { determineIfActiveObject, determineIfActiveBoolean, determineIfActiveArray },
  components: { ActiveFilterIndicator, NumberInput, DatePicker },
})
export default class SidePanelFilter extends Vue {
  @Inject('gebruikerService') gebruikerService: GebruikerService;
  @Prop({ default: false }) showFilter: boolean;
  @Prop({ default: false }) isImport: boolean;
  @Prop({ default: Array }) excludedFilters: string[];
  filterHeight = 750;
  filterOptions = {
    energiedeskundigen: [],
    certificaatStatussen: [],
    opdrachtStatussen: [],
    bestemmingen: [],
    booleanOptie: [
      {
        text: 'Ja',
        value: true,
      },
      {
        text: 'Neen',
        value: false,
      },
    ],
    labels: [],
  };
  @Prop() savedFilter: Filter;
  filter: Filter = {} as Filter;

  @Watch('savedFilter', { deep: true })
  updateFilter() {
    this.filter = JSON.parse(JSON.stringify(this.savedFilter));
  }

  created() {
    this.filter = JSON.parse(JSON.stringify(this.savedFilter));
  }

  mounted(): void {
    this.gebruikerService.getGebruikers().then((data) => {
      this.filterOptions.energiedeskundigen = data;
    });
    fetchIndependentEnum('DocumentStatus', ['ONGELDIG']).then((items) => {
      this.filterOptions.certificaatStatussen = items;
    });
    fetchIndependentEnum('OpdrachtStatus', ['VEROUDERD']).then((items) => {
      this.filterOptions.opdrachtStatussen = items;
    });
    fetchIndependentEnum('Bestemming', []).then((items) => {
      this.filterOptions.bestemmingen = items;
    });
    fetchIndependentEnum('EnergieLabel', []).then((items) => {
      this.filterOptions.labels = items.sort((a, b) => a.omschrijving.localeCompare(b.omschrijving));
    });
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize);
    });
  }

  handleSave() {
    if (this.validateEnergiescoreInput()) {
      this.$emit('saveFilter', JSON.parse(JSON.stringify(this.filter)));
    }
  }

  cancel() {
    this.filter = JSON.parse(JSON.stringify(this.savedFilter));
    this.$emit('cancelFilter');
  }

  clearData(field: string, subField: string) {
    let filterElement = this.filter[field];
    if (filterElement[subField] !== undefined) {
      filterElement[subField] = null;
    } else {
      filterElement = null;
    }
  }

  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  }

  onResize() {
    if (this.isImport) {
      this.filterHeight = 549;
    } else {
      this.filterHeight = window.innerHeight - 65;
    }
  }

  toggleAllOrNothing(values: string[], options: EnumInterface[]): string[] {
    return values.length === options.length ? values.filter(() => false) : options.map((item) => item.code);
  }

  validateEnergiescoreInput(): boolean {
    if (this.filter.energiescore.van !== null && this.filter.energiescore.tot !== null) {
      return this.filter.energiescore.van <= this.filter.energiescore.tot;
    }
    return true;
  }
}
</script>
